import React from "react";
import styled from "styled-components"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicketAlt } from "@fortawesome/free-solid-svg-icons";

import colors from "../settings/colors"

const Button = styled.a`
    display: inline-block;
    background-color: ${colors.orange};
    font-size: 16px !important;
    line-height: 1em;
    padding: 8px 16px !important;
    color: white !important;
    border: 1px solid ${colors.orange};
    text-decoration: none;
    border-radius: 5px;
    transition: transform .2s;
    white-space: nowrap;

    svg {
        margin-right: 10px;
    }

    &:hover {
        transform: scale(1.1);
    }
    &.small {
        padding: 4px 8px  !important;
        font-size: 12px !important;

        svg {
            margin-right: 3px;
        }        
    }
`

function TicketsButton({show, small}) {
  return (
        <Button href={show.tickets} target="_blank" className={small ? "small":""}>
            <FontAwesomeIcon icon={faTicketAlt} />{' '}
            Purchase Tickets
        </Button>
  );
}

export default TicketsButton;